import styled, { css } from 'styled-components';
import FluffyCard from '@gotamedia/fluffy/Card';
const Card = styled(FluffyCard).withConfig({
  displayName: "style__Card",
  componentId: "sc-1uutkan-0"
})(["border-radius:0px;&:hover{cursor:pointer;background:#f2f2f2;}"]);
const ImageWrapper = styled.div.withConfig({
  displayName: "style__ImageWrapper",
  componentId: "sc-1uutkan-1"
})(["padding:12px;position:relative;", ""], ({
  $overflow
}) => $overflow && css(["         &:after{content:\"\";width:100%;height:100%;position:absolute;background:linear-gradient(rgba(255,255,255,0) 0%,rgba(255,255,255,0.5) 80%,rgb(255,255,255) 100%);top:0;right:0;bottom:0;left:0;}"]));
const CardImage = styled(Card.Image).withConfig({
  displayName: "style__CardImage",
  componentId: "sc-1uutkan-2"
})(["width:100%;height:100%;aspect-ratio:2/3;position:relative;", ""], ({
  $overflow
}) => $overflow && css(["object-fit:cover;object-position:top;"]));
export { Card, ImageWrapper, CardImage };